import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { downloadSessionFailed, downloadSessionSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* downloadSession(action) {
  try {
    const ids = action.payload;
    const url = `${BACKEND_URL}/api/v1/session/download`;
    const dataResponse = yield makeRequest(url, { ids }, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(downloadSessionSuccessful());
      const timestamp = dataResponse.headers.get('X-Snapshot-Timestamp') || '';
      yield call(resolveActionPromise(action, { data, timestamp }));
    } else {
      yield put(downloadSessionFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(downloadSessionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
